/**
 * @generated SignedSource<<b31fc3349f4a1e9b12d42c736dc61b39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MeetingRecordingClipVisibility = "PRIVATE" | "PUBLIC" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type ShareClipModal_clip$data = {
  readonly id: string;
  readonly ownerAccount: {
    readonly allowPublicRecap: boolean;
  };
  readonly visibility: MeetingRecordingClipVisibility;
  readonly " $fragmentSpreads": FragmentRefs<"ShareClipModal_postedChannels" | "utils_useGetURL_recording">;
  readonly " $fragmentType": "ShareClipModal_clip";
};
export type ShareClipModal_clip$key = {
  readonly " $data"?: ShareClipModal_clip$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareClipModal_clip">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareClipModal_clip",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowPublicRecap",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useGetURL_recording"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShareClipModal_postedChannels"
    }
  ],
  "type": "MeetingRecordingClip",
  "abstractKey": null
};

(node as any).hash = "d78011426be469eefb4fdff28eb1f548";

export default node;
